import React from 'react';
import { FaDiscord, FaYoutube, FaInstagram, FaTiktok } from 'react-icons/fa';

function Footer() {
  return (
    <footer className="bg-[#0b0c10] text-gray-400 py-6 mt-0"> 
      <div className="max-w-6xl mx-auto px-4 flex flex-col md:flex-row justify-between items-center">
        
        {/* Brand Info */}
        <div className="mb-4 md:mb-0 text-center md:text-left">
          <h4 className="text-lg font-bold text-orange-400">RF FUN SERVER</h4>
          <p className="text-sm text-gray-400">
            © 2025 All rights reserved. Powered by MasterDev
          </p>
        </div>

        {/* Social Media Links */}
        <div className="flex space-x-6 text-lg">
          <a
            href="https://discord.gg/qFsPTq2Nwr"
            target="_blank"
            rel="noreferrer"
            className="hover:text-orange-400 flex items-center gap-2"
          >
            <FaDiscord /> Discord
          </a>
          <a
            href="https://youtube.com/alfathars"
            target="_blank"
            rel="noreferrer"
            className="hover:text-orange-400 flex items-center gap-2"
          >
            <FaYoutube /> YouTube
          </a>
          <a
            href="https://instagram.com/rffunserver"
            target="_blank"
            rel="noreferrer"
            className="hover:text-orange-400 flex items-center gap-2"
          >
            <FaInstagram /> Instagram
          </a>
          <a
            href="https://www.tiktok.com/@rffunserver"
            target="_blank"
            rel="noreferrer"
            className="hover:text-orange-400 flex items-center gap-2"
          >
            <FaTiktok /> TikTok
          </a>
        </div>

      </div>
    </footer>
  );
}

export default Footer;
